<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-container
          v-if="projects && projects.length === 0"
          class="d-flex justify-center mb-12"
        >
          <span class="body-1">
            {{ $t("project_list.no_projects") }}
          </span>
        </v-container>

        <v-row
          class="d-flex justify-end mb-10"
          :class="
            projects && projects.length > 0 ? 'justify-end' : 'justify-center'
          "
        >
          <niko-button
            icon-before="$iconAdd"
            :text="$t('project_list.add')"
            @onClick="handleAddNewProjectModal"
            primary
          ></niko-button>
        </v-row>

        <v-list
          outlined
          :color="$vuetify.theme.dark ? '#1A1A1a' : 'grey lighten-2'"
          class="project-list"
        >
          <v-list-item-group
            outlined
            style="max-height: 500px"
            class="overflow-y-auto"
          >
            <template v-for="(project, index) in projects">
              <div :key="project.project_id">
                <v-divider v-if="index === 0"></v-divider>

                <v-list-item
                  @click="openProject(project, index)"
                  class="project-list-item"
                  :class="{
                    black50: index < projects.length - 3 && !activeSubscription,
                  }"
                  outlined
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ project.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      project.buildings.length > 1
                        ? $t("project_list.buildings", [
                            project.buildings.length,
                          ])
                        : project.buildings.length === 1
                        ? project.buildings[0].address
                        : ""
                    }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-container class="d-flex row pa-0 ma-0 align-center">
                      <h4
                        v-if="project.state"
                        style="width: 140px"
                        class="mr-4"
                      >
                        {{ projectState(project.state) }}
                      </h4>
                      <niko-container-dropdown
                        :items="getDropdownItems(project, index)"
                        @clicked="executeSelectedAction($event)"
                        :project="project"
                        width="205px"
                        height="160px"
                        :greydOut="
                          index < projects.length - 3 && !activeSubscription
                        "
                      />
                    </v-container>
                  </v-list-item-action>
                </v-list-item>

                <v-divider></v-divider>
              </div>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
    <niko-modal
      :isVisible="isProjectSizeWarningModalVisible"
      :inputs="[]"
      :title="$t('project_list.modal.add.title')"
      :primaryButtonText="$t('project_list.modal.buttons.agree')"
      :secondaryButtonText="$t('project_list.modal.buttons.cancel')"
      :info="$t('project_list.modal.project_size.warning')"
      @onSubmit="
        isProjectSizeWarningModalVisible = false;
        isAddProjectModalVisible = true;
      "
      @onClose="isProjectSizeWarningModalVisible = false"
    />
    <niko-modal
      :isVisible="isAddProjectModalVisible"
      :inputs="addProjectModalInputs"
      :title="$t('project_list.modal.add.title')"
      :primaryButtonText="$t('project_list.modal.buttons.add')"
      :secondaryButtonText="$t('project_list.modal.buttons.cancel')"
      :caption="$t('project.modal.standard_info')"
      @onSubmit="addNew"
      @onClose="isAddProjectModalVisible = false"
    />
    <niko-modal
      v-if="selectedProject"
      :isVisible="isDeletingModalVisible"
      :title="$t('project_list.modal.delete.title')"
      :warning="$t('project_list.modal.delete.warning')"
      :inputs="[]"
      :primaryButtonText="$t('project_list.modal.buttons.delete')"
      :secondaryButtonText="$t('project_list.modal.buttons.cancel')"
      @onSubmit="onDelete"
      @onClose="
        isDeletingModalVisible = false;
        selectedProject = null;
      "
    />
    <niko-modal-wrapper
      v-if="selectedProject"
      :showModal="isRollbackModalVisible"
      :title="$t(`project_list.modal.rollback.${selectedProject.state}.title`)"
      :primaryButtonText="
        $t(`project_list.modal.rollback.${selectedProject.state}.button`)
      "
      :secondaryButtonText="$t('project_list.modal.buttons.cancel')"
      @onSubmit="onRollback"
      @onClose="
        isRollbackModalVisible = false;
        selectedProject = null;
      "
      ><p class="mt-4 mb-8">
        {{
          this.$t(`project_list.modal.rollback.${selectedProject.state}.text`)
        }}
      </p></niko-modal-wrapper
    >
    <share
      v-if="selectedProject"
      :isVisible="isShareModalVisible"
      :projectName="selectedProject.name"
      @onClose="isShareModalVisible = false"
    />
    <niko-modal-wrapper
      :showModal="isGeneralUpgradeModalVisible"
      :title="$t('premium.modal.title')"
      :primaryButtonText="$t('premium.modal.primary_button')"
      @onClose="isGeneralUpgradeModalVisible = false"
      @onSubmit="openFastSpringPopup"
      ><p class="body1 mt-9 mb-7">
        {{ $t("premium.modal.general_text") }}
      </p></niko-modal-wrapper
    >
    <niko-modal-wrapper
      :showModal="isProjectLimitUpgradeModalVisible"
      :title="$t('premium.modal.title')"
      :primaryButtonText="$t('premium.modal.primary_button')"
      @onClose="isProjectLimitUpgradeModalVisible = false"
      @onSubmit="openFastSpringPopup"
    >
      <p class="body1 mt-9 mb-7">
        {{ $t("premium.modal.project_limit_text") }}
      </p>
    </niko-modal-wrapper>
    <niko-modal-wrapper
      :showModal="isRemovingProjectModalVisible"
      :title="$t('project_list.modal.remove.title')"
      :primaryButtonText="$t('project_list.modal.buttons.remove')"
      :secondaryButtonText="$t('project_list.modal.buttons.cancel')"
      @onClose="isRemovingProjectModalVisible = false"
      @onSubmit="removeProject"
    >
      <p class="body1 mt-9 mb-7">
        {{ $t("project_list.modal.remove.text") }}
      </p>
    </niko-modal-wrapper>
  </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import NikoButton from "./UI/NikoButton";
import NikoModal from "./UI/NikoModal";
import NikoModalWrapper from "./UI/NikoModalWrapper";
import NikoContainerDropdown from "./UI/NikoContainerDropdown";
import Share from "@/components/share/Share";
import { getProjectStatePresentationName } from "@/utils/projectStateHelpers";

export default {
  name: "list-of-projects",
  components: {
    NikoContainerDropdown,
    NikoButton,
    NikoModal,
    NikoModalWrapper,
    Share,
  },
  data: function () {
    return {
      selectedProject: null,
      isAddProjectModalVisible: false,
      isDeletingModalVisible: false,
      isRemovingProjectModalVisible: false,
      isShareModalVisible: false,
      isGeneralUpgradeModalVisible: false,
      isProjectLimitUpgradeModalVisible: false,
      isRollbackModalVisible: false,
      isProjectSizeWarningModalVisible: false,
    };
  },
  computed: {
    ...mapState("projectsStore", ["projects"]),
    ...mapState("projectStore", [
      "name",
      "standard",
      "available_standards",
      "equipments",
      "buildings",
    ]),
    ...mapState("authStore", [
      "activeSubscription",
      "email",
      "firstname",
      "lastname",
    ]),
    ...mapState("loaderStore", ["cancelPdfGeneration"]),
    addProjectModalInputs() {
      return [
        {
          label: this.$i18n.t("project_list.modal.add.project"),
          value: this.name,
          mutation: "projectStore/updateProjectName",
        },
        {
          label: this.$i18n.t("project_list.modal.add.fa_standard"),
          value: this.standard,
          mutation: "projectStore/updateStandard",
          selectValues: this.available_standards,
          selectItemText: "standard_name",
          selectItemValue: "standard_id",
          rules: [
            (v) =>
              !!v || this.$i18n.t("project_list.modal.add.fa_standard_error"),
          ],
        },
      ];
    },
  },
  methods: {
    ...mapMutations("projectStore", [
      "setProjectId",
      "setGeneratingPdf",
      "resetProjectState",
    ]),
    ...mapMutations("projectsStore", [
      "setSelectedProjectId",
      "setSelectedProjectEmails",
    ]),
    ...mapMutations("loaderStore", [
      "setIsLoading",
      "setFinishPdfProgress",
      "setCancelPdfGeneration",
    ]),
    ...mapMutations("buildingStore", ["resetBuildingState"]),
    ...mapMutations("floorStore", ["resetFloorState"]),
    ...mapActions("projectStore", [
      "addNewProject",
      "getProjectById",
      "setProjectState",
      "generatePdf",
    ]),
    ...mapActions("projectsStore", ["revokeOwnAccess"]),
    openProject(project, index) {
      if (index < this.projects.length - 3 && !this.activeSubscription) {
        this.isProjectLimitUpgradeModalVisible = true;
      } else {
        this.setProjectId(project.project_id);
        this.$router.push(`project/${project.project_id}`);
      }
    },
    getDropdownItems(project, index) {
      let items;
      if (
        index < this.projects.length - 3 &&
        !this.activeSubscription &&
        project.users.length > 0
      ) {
        items = [
          {
            value: this.$i18n.t("project_list.dropdown.remove_project"),
            warning: true,
          },
        ];
      } else if (
        index < this.projects.length - 3 &&
        !this.activeSubscription &&
        project.users.length === 0
      ) {
        items = [
          {
            value: this.$i18n.t("project_list.dropdown.delete_project"),
            warning: true,
          },
        ];
      } else {
        items = [
          this.$i18n.t("project_list.dropdown.share"),
          {
            value:
              this.activeSubscription || project.users.length === 0
                ? this.$i18n.t("project_list.dropdown.delete_project")
                : this.$i18n.t("project_list.dropdown.remove_project"),
            warning: true,
          },
          this.$i18n.t("project_list.dropdown.generate_report"),
        ];
        if (project.state !== "in_configuration") {
          items.unshift(
            this.$i18n.t(`project_list.dropdown.rollback.${project.state}`)
          );
        }
      }
      return items;
    },
    addNew() {
      this.setIsLoading(true);
      this.addNewProject().then(() => {
        this.setIsLoading(false);
      });
    },
    projectState(state) {
      return getProjectStatePresentationName(state);
    },
    deleteProjectClicked(project) {
      this.selectedProject = project;
      this.isDeletingModalVisible = true;
    },
    async executeSelectedAction(data) {
      if (data.value === this.$i18n.t("project_list.dropdown.delete_project")) {
        this.deleteProjectClicked(data.project);
      } else if (
        data.value === this.$i18n.t("project_list.dropdown.share") &&
        this.activeSubscription
      ) {
        this.isShareModalVisible = true;
        this.selectedProject = data.project;
        this.setSelectedProjectId(data.project.project_id);
        const selectedProjectEmails = data.project.users.map(
          (user) => user.email
        );
        this.setSelectedProjectEmails(selectedProjectEmails || []);
      } else if (data.value === this.$i18n.t("project_list.dropdown.share")) {
        this.isGeneralUpgradeModalVisible = true;
      } else if (
        data.value === this.$i18n.t("project_list.dropdown.generate_report")
      ) {
        this.setIsLoading(true);
        this.setGeneratingPdf(true);
        await this.getProjectById(data.project.project_id);
        let noOfRooms = 0;
        this.buildings.forEach((building) => {
          building.floors.forEach((floor) => {
            if (floor.rooms) {
              noOfRooms = noOfRooms + floor.rooms.length;
            }
          });
        });
        if (noOfRooms === 0) {
          this.resetProjectState();
          this.resetBuildingState();
          this.resetFloorState();
          this.setCancelPdfGeneration(false);
          this.setIsLoading(false);
          return;
        }
        if (this.cancelPdfGeneration) {
          this.resetProjectState();
          this.resetBuildingState();
          this.resetFloorState();
          this.setCancelPdfGeneration(false);
          return;
        }
        await this.generatePdf();
        if (!this.cancelPdfGeneration) {
          this.setFinishPdfProgress(true);
          setTimeout(() => {
            this.setIsLoading(false);
            this.setGeneratingPdf(false);
            this.resetProjectState();
            this.resetBuildingState();
            this.resetFloorState();
            this.setFinishPdfProgress(false);
          }, 1000);
        } else {
          this.setCancelPdfGeneration(false);
          this.resetProjectState();
          this.resetBuildingState();
          this.resetFloorState();
        }
      } else if (
        data.value === this.$i18n.t("project_list.dropdown.remove_project")
      ) {
        this.selectedProject = data.project;
        this.isRemovingProjectModalVisible = true;
      } else if (!this.activeSubscription && data.project.users.length > 0) {
        this.isGeneralUpgradeModalVisible = true;
      } else {
        this.isRollbackModalVisible = true;
        this.selectedProject = data.project;
      }
    },
    async onDelete() {
      await this.setProjectState({
        project_id: this.selectedProject.project_id,
        newState: "deleted",
      });
      this.isDeletingModalVisible = false;
      this.isProjectLimitUpgradeModalVisible =
        !this.activeSubscription && this.projects.length > 3;
    },
    async onRollback() {
      let newState;
      switch (this.selectedProject.state) {
        case "in_testing":
          newState = "in_configuration";
          break;
        case "in_evaluation":
          newState = "in_testing";
          break;
        case "completed":
          newState = "in_evaluation";
      }
      this.isRollbackModalVisible = false;
      await this.setProjectState({
        project_id: this.selectedProject.project_id,
        newState,
      });
      this.$router.push(`project/${this.selectedProject.project_id}`);
    },
    openFastSpringPopup() {
      this.isGeneralUpgradeModalVisible = false;
      this.isProjectLimitUpgradeModalVisible = false;
      window.fastspring.builder.recognize({
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
      });
      window.fastspring.builder.add("fa-assistent-premium");
      window.fastspring.builder.checkout();
    },
    handleAddNewProjectModal() {
      this.isProjectSizeWarningModalVisible =
        this.activeSubscription || this.projects.length < 3;
      this.isProjectLimitUpgradeModalVisible =
        !this.activeSubscription && this.projects.length >= 3;
    },
    removeProject() {
      this.revokeOwnAccess({
        email: this.email,
        project_id: this.selectedProject.project_id,
      });
      this.isRemovingProjectModalVisible = false;
      this.isProjectLimitUpgradeModalVisible =
        !this.activeSubscription && this.projects.length > 3;
    },
  },
};
</script>

<style lang="scss">
.v-text-field--full-width .v-input__append-inner,
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 7px !important;
}

/* By making the list black, the scroll bar disappeared in dark mode */
.project-list {
  ::-webkit-scrollbar {
    background-color: #202324;
    color: #aba499;
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #454a4d;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #575e62;
  }
  ::-webkit-scrollbar-thumb:active {
    background-color: #484e51;
  }
  ::-webkit-scrollbar-corner {
    background-color: #181a1b;
  }
}

.search-field {
  border-color: khaki;
}
.project-list-item {
  min-height: 80px !important;
}
</style>
